import { TileCategory, TileSubCategory } from "./tilesTypes";

export const tileCategories: TileCategory[] = [
  {
    id: 1,
    name: "Floor Tiles",
    description:
      "Designed to be durable, hard-wearing, and slip-resistant for high-traffic areas. Perfect for all interior flooring needs with superior strength and style.",
    keyCharacteristics: [
      "High PEI rating for abrasion resistance",
      "Textured or matte finish for grip",
      "High breaking strength",
      "Slip-resistant surface",
    ],
    commonMaterials: [
      "Porcelain (most popular)",
      "Ceramic",
      "Natural Stone (Slate, Granite)",
      "Polished Concrete",
      "Terracotta",
    ],
    primaryUse: [
      "Living rooms",
      "Bedrooms",
      "Hallways",
      "Kitchens",
      "Commercial spaces",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop", // Modern living room floor tiles
      "https://images.unsplash.com/photo-1560807707-8cc77767d783?w=800&h=600&fit=crop", // Wooden floor tiles pattern
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop", // Ceramic floor installation
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Large format floor tiles
      "https://images.unsplash.com/photo-1554995207-c18c203602cb?w=800&h=600&fit=crop", // Polished porcelain floor
      "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&h=600&fit=crop", // Kitchen floor tiles
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Marble floor tiles luxury
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop", // Textured floor tiles
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Stone-look floor tiles
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Modern floor tile design
      "https://images.unsplash.com/photo-1595428774223-ef52624120d2?w=800&h=600&fit=crop", // Premium floor finish
      "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop", // Contemporary floor tiles
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    peiRating: "PEI IV-V",
    slipResistance: "R10-R11",
    specifications: {
      thickness: "8-12mm",
      sizes: ["300x300mm", "600x600mm", "800x800mm", "1200x600mm"],
      finish: ["Matte", "Textured", "Anti-slip", "Polished"],
      installation: "Adhesive fixing on prepared substrate",
      maintenance: "Regular cleaning with mild detergent",
    },
    useCases: [
      {
        location: "Indoor Flooring (Living Room)",
        recommendation: "Porcelain Tiles, Ceramic Tiles",
        keyChecks: ["PEI Rating IV or V", "Slip Resistance R10/R11"],
      },
      {
        location: "Kitchen Floor",
        recommendation: "Porcelain Tiles, Quarry Tiles",
        keyChecks: ["Slip Resistance R10/R11", "Stain Resistance"],
      },
    ],
    priceRange: "₹45 - ₹180 per sq ft",
    availability: "In Stock",
    rating: 4.8,
    reviews: 324,
    isPopular: true,
  },
  {
    id: 2,
    name: "Wall Tiles",
    description:
      "Primarily for decorative purposes, designed to enhance the aesthetic appeal of interior walls with beautiful finishes and patterns.",
    keyCharacteristics: [
      "Lighter and thinner design",
      "Decorative focus",
      "Glossy, smooth, or textured finish",
      "Lower PEI rating sufficient",
    ],
    commonMaterials: [
      "Ceramic",
      "Porcelain",
      "Glass",
      "Metal",
      "Mother of Pearl",
    ],
    primaryUse: [
      "Feature walls",
      "Bathroom walls",
      "Kitchen walls",
      "Shower surrounds",
      "Decorative accents",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Bathroom wall tiles
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=600&fit=crop", // Kitchen backsplash tiles
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=600&fit=crop", // Shower wall tiles
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Marble wall tiles
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Subway wall tiles
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Decorative wall tiles
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop", // Wall tile patterns
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop", // Modern wall design
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    peiRating: "PEI I-III",
    specifications: {
      thickness: "6-10mm",
      sizes: ["200x300mm", "300x450mm", "300x600mm", "400x800mm"],
      finish: ["Glossy", "Matte", "Textured", "Digital Print"],
      installation: "Wall adhesive application",
      maintenance: "Easy cleaning with standard cleaners",
    },
    useCases: [
      {
        location: "Wall (Decorative)",
        recommendation: "Ceramic Wall Tiles, Glass Tiles",
        keyChecks: ["PEI Rating I-III sufficient", "Aesthetic appeal"],
      },
    ],
    priceRange: "₹25 - ₹150 per sq ft",
    availability: "In Stock",
    rating: 4.6,
    reviews: 267,
  },
  {
    id: 3,
    name: "Countertop / Worktop Tiles",
    description:
      "Heavy-duty tiles for creating durable and heat-resistant surfaces in kitchens and bathrooms. Built to withstand daily use and maintain beauty.",
    keyCharacteristics: [
      "Highly resistant to scratches",
      "Stain resistant",
      "Heat resistant",
      "Chemical resistant",
      "Easy to clean and maintain",
    ],
    commonMaterials: ["Porcelain", "Granite", "Quartzite", "Marble", "Ceramic"],
    primaryUse: [
      "Kitchen countertops",
      "Kitchen islands",
      "Bathroom vanities",
      "Work surfaces",
      "Bar tops",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Granite countertop tiles
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Marble countertop surface
      "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&h=600&fit=crop", // Kitchen island countertop
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Quartz countertop tiles
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Bathroom vanity tiles
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Modern countertop design
      "https://images.unsplash.com/photo-1595428774223-ef52624120d2?w=800&h=600&fit=crop", // Polished counter surface
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop", // Luxury countertop finish
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    specifications: {
      thickness: "12-20mm",
      sizes: ["600x300mm", "800x400mm", "1200x600mm", "Custom sizes"],
      finish: ["Polished", "Honed", "Leathered", "Brushed"],
      installation: "Professional installation recommended",
      maintenance: "Periodic sealing for natural stone",
    },
    useCases: [
      {
        location: "Countertop",
        recommendation: "Porcelain Slabs, Granite, Marble",
        keyChecks: [
          "Stain Resistance",
          "Heat Resistance",
          "Sealing for natural stone",
        ],
      },
    ],
    priceRange: "₹120 - ₹500 per sq ft",
    availability: "In Stock",
    rating: 4.9,
    reviews: 156,
    isNew: true,
  },
  {
    id: 4,
    name: "Paver Tiles",
    description:
      "Extra-durable tiles designed for outdoor and heavy-traffic use. Engineered to withstand weather, freeze-thaw cycles, and heavy loads.",
    keyCharacteristics: [
      "Extra thick and durable",
      "Highly slip-resistant",
      "Frost-proof design",
      "Weather resistant",
      "Heavy load bearing",
    ],
    commonMaterials: [
      "Porcelain (through-body color)",
      "Quarry Tiles",
      "Natural Stone (Bluestone, Sandstone)",
      "Concrete Pavers",
    ],
    primaryUse: [
      "Patios",
      "Pool decks",
      "Walkways",
      "Driveways",
      "Commercial plazas",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1560807707-8cc77767d783?w=800&h=600&fit=crop", // Outdoor patio pavers
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&h=600&fit=crop", // Stone paver walkway
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop", // Pool deck pavers
      "https://images.unsplash.com/photo-1516455590571-18256e5bb9ff?w=800&h=600&fit=crop", // Driveway paver stones
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Commercial plaza pavers
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Natural stone pavers
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Textured paver design
      "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop", // Outdoor paver patterns
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    slipResistance: "R11+",
    specifications: {
      thickness: "15-30mm",
      sizes: ["300x300mm", "400x400mm", "600x600mm", "600x900mm"],
      finish: ["Textured", "Bush-hammered", "Sandblasted", "Natural"],
      installation: "Sand bed or adhesive installation",
      maintenance: "Pressure washing, periodic sealing",
    },
    useCases: [
      {
        location: "Outdoor Patio",
        recommendation: "Porcelain Pavers, Natural Stone",
        keyChecks: ["Frost-proof rating", "Slip Resistance R11+"],
      },
    ],
    priceRange: "₹80 - ₹350 per sq ft",
    availability: "In Stock",
    rating: 4.7,
    reviews: 198,
  },
  {
    id: 5,
    name: "Roof Tiles",
    description:
      "Specialized tiles for roofing applications, focusing on weatherproofing, insulation, and architectural aesthetics for long-lasting protection.",
    keyCharacteristics: [
      "Interlocking design",
      "Water shedding efficiency",
      "UV resistant",
      "Weather durable",
      "Thermal insulation",
    ],
    commonMaterials: [
      "Clay (Terracotta)",
      "Concrete",
      "Slate",
      "Metal composite",
    ],
    primaryUse: [
      "Pitched roofing",
      "Houses and buildings",
      "Heritage structures",
      "Commercial roofing",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1516455590571-18256e5bb9ff?w=800&h=600&fit=crop", // Clay roof tiles
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&h=600&fit=crop", // Traditional roof tiles
      "https://images.unsplash.com/photo-1560807707-8cc77767d783?w=800&h=600&fit=crop", // Modern roof design
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop", // Red roof tiles
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Terracotta roof tiles
      "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop", // Commercial roof tiles
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Heritage roof tiles
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Slate roof tiles
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    specifications: {
      thickness: "12-25mm",
      sizes: ["Standard profiles", "Custom lengths", "Interlocking systems"],
      finish: ["Natural clay", "Glazed", "Color coated", "Textured"],
      installation: "Professional roofing installation",
      maintenance: "Annual inspection, gutter cleaning",
    },
    useCases: [
      {
        location: "Residential Roofing",
        recommendation: "Clay Tiles, Concrete Tiles",
        keyChecks: [
          "Weather resistance",
          "Interlocking system",
          "Load bearing",
        ],
      },
    ],
    priceRange: "₹60 - ₹200 per sq ft",
    availability: "Limited Stock",
    rating: 4.5,
    reviews: 89,
  },
  {
    id: 6,
    name: "Specialty / Mosaic Tiles",
    description:
      "Small format tiles used for accents, borders, and intricate designs. Perfect for creating stunning patterns and artistic features.",
    keyCharacteristics: [
      "Small size format",
      "Sheet-mounted for easy installation",
      "Pattern and design focus",
      "Decorative emphasis",
      "Versatile applications",
    ],
    commonMaterials: [
      "Glass",
      "Stone",
      "Metal",
      "Porcelain",
      "Shell",
      "Mother of Pearl",
    ],
    primaryUse: [
      "Backsplashes",
      "Shower niches",
      "Decorative borders",
      "Swimming pools",
      "Feature designs",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Mosaic tile patterns
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Glass mosaic tiles
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=600&fit=crop", // Decorative backsplash
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop", // Pool mosaic tiles
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Artistic mosaic design
      "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop", // Small format mosaics
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Luxury mosaic patterns
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=600&fit=crop", // Feature wall mosaics
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    specifications: {
      thickness: "4-8mm",
      sizes: ["15x15mm", "25x25mm", "50x50mm", "Mixed sizes"],
      finish: ["Glossy", "Iridescent", "Matte", "Metallic", "Frosted"],
      installation: "Sheet mounting, precision cutting",
      maintenance: "Gentle cleaning, avoid abrasives",
    },
    useCases: [
      {
        location: "Backsplash",
        recommendation: "Ceramic, Glass, or Metal Mosaics",
        keyChecks: ["Ease of cleaning", "Aesthetic match to countertop"],
      },
      {
        location: "Bathroom/Shower Floor",
        recommendation: "Mosaic Tiles, Small-format tiles",
        keyChecks: ["High Slip Resistance R11/R12", "Water absorption <3%"],
      },
    ],
    priceRange: "₹150 - ₹800 per sq ft",
    availability: "In Stock",
    rating: 4.4,
    reviews: 234,
    isPopular: true,
  },
];

export const tileSubCategories: TileSubCategory[] = [
  // Floor Tiles Sub-categories
  {
    id: 1,
    categoryId: 1,
    name: "Porcelain Floor Tiles",
    description:
      "Premium porcelain tiles with superior durability and water resistance",
    image: "/api/placeholder/300/300",
    features: ["Water resistant", "Scratch proof", "Easy maintenance"],
    specifications: ["Size: 600x600mm", "Thickness: 10mm", "Finish: Matte"],
    applications: ["Living rooms", "Kitchens", "Commercial spaces"],
  },
  {
    id: 2,
    categoryId: 1,
    name: "Ceramic Floor Tiles",
    description:
      "Cost-effective ceramic tiles perfect for residential applications",
    image: "/api/placeholder/300/300",
    features: ["Affordable", "Variety of designs", "Easy installation"],
    specifications: ["Size: 300x300mm", "Thickness: 8mm", "Finish: Glazed"],
    applications: ["Bedrooms", "Hallways", "Low-traffic areas"],
  },
  // Wall Tiles Sub-categories
  {
    id: 3,
    categoryId: 2,
    name: "Ceramic Wall Tiles",
    description: "Decorative ceramic tiles for beautiful wall installations",
    image: "/api/placeholder/300/300",
    features: ["Decorative", "Color variety", "Easy cleaning"],
    specifications: ["Size: 300x450mm", "Thickness: 7mm", "Finish: Glossy"],
    applications: ["Bathroom walls", "Kitchen walls", "Feature walls"],
  },
  {
    id: 4,
    categoryId: 2,
    name: "Glass Wall Tiles",
    description: "Elegant glass tiles for premium wall applications",
    image: "/api/placeholder/300/300",
    features: ["Elegant finish", "Light reflection", "Stain resistant"],
    specifications: ["Size: 300x300mm", "Thickness: 6mm", "Finish: Glossy"],
    applications: ["Shower walls", "Backsplashes", "Accent walls"],
  },
];
